import flexPaneOpened from '../actions/flexPaneOpened';
import getO365ShellShim from '../../utils/getO365ShellShim';
import { orchestrator } from 'satcheljs';
import { isFeatureEnabled } from 'owa-feature-flags';

let isFlexPaneCallbackDefined: boolean = false;
const FLUENT_LAYER_HOST_ID = 'fluent-default-layer-host';
const FLEX_PANE_OVERFLOW_CONTAINER_ID = 'FlexPane_Overflow_Container';
const FLEXPANE_CONTAINER_ID = 'O365fpcontainerid';
const DEFAULT_BIZCHAT_WIDTH = 380;

//TODO: WI 152412 Remove DOM manipulation logic once Layers in FlexPane are inserted in the Fluent layer host
/* eslint-disable-next-line owa-custom-rules/forbid-orchestrator-in-same-package -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!
 *	> Do not register an orchestrator with an action that is defined in the same package */
orchestrator(flexPaneOpened, () => {
    const shim = getO365ShellShim();
    if (shim && !isFlexPaneCallbackDefined) {
        shim.FlexPane.OnFlexPaneVisibilityChanged((isVisible, props) => {
            if (isVisible) {
                const fluentLayerHost = document.getElementById(FLUENT_LAYER_HOST_ID);
                const flexPaneOverflowContainer = document.getElementById(
                    FLEX_PANE_OVERFLOW_CONTAINER_ID
                );
                const flexPaneContainer = document.getElementById(FLEXPANE_CONTAINER_ID);
                if (fluentLayerHost && flexPaneOverflowContainer && flexPaneContainer) {
                    if (
                        isFeatureEnabled('mon-copilot-bizchat') &&
                        props.providerId === 'ChatCopilot' &&
                        props.width == 320
                    ) {
                        // Update the default width of the FlexPane for BizChat which is 380px
                        flexPaneContainer.style.width = DEFAULT_BIZCHAT_WIDTH + 'px';
                        flexPaneOverflowContainer.style.width = DEFAULT_BIZCHAT_WIDTH + 60 + 'px';
                    }
                    document.body.insertBefore(flexPaneOverflowContainer, fluentLayerHost);
                }
            }
        });
        isFlexPaneCallbackDefined = true;
    }
});
